module.exports = {
  title: 'OEM替换关系',
  route: {
    path: '/platform-goods-manage',
    children: {
      path: 'oem-replace-relation',
    },
  },
};
